import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Button,
  TablePagination,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Menu,
  MenuItem,
  IconButton,
  Avatar,
  useTheme,
  useMediaQuery,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BarChartIcon from "@mui/icons-material/BarChart";
import SettingsIcon from "@mui/icons-material/Settings";
import ReceiptIcon from "@mui/icons-material/Receipt";
import DescriptionIcon from "@mui/icons-material/Description";
import { Menu as MenuIcon } from "@mui/icons-material";
import Header2 from "../../Component/Header2";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ChatWithCustomer from "../../Component/Chatbot/ChatWithCustomer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { QRCodeSVG } from "qrcode.react";
import { toPng } from "html-to-image";
import QrCodeIcon from "@mui/icons-material/QrCode"; // MUI icon
import StoreIcon from "@mui/icons-material/Store";
import PaymentIcon from "@mui/icons-material/Payment";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import UploadFileIcon from "@mui/icons-material/UploadFile";

function CreateShopKeeperInv() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const userName = localStorage.getItem("username") || "Shopkeeper";
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const isProfileMenuOpen = Boolean(profileAnchorEl);
  const [openDialog, setOpenDialog] = useState(false);
  const [localProducts, setLocalProducts] = useState([]);
  const [OpenAddDialog, setOpenAddDialog] = useState();
  const [showInventoryTable, setShowInventoryTable] = useState(false);
  const [shopName, setShopName] = useState();
  const tableRef = useRef(null);
  // ✅ All logic already as required.
  const [customProducts, setCustomProducts] = useState(() => {
    return JSON.parse(localStorage.getItem("customProducts")) || [];
  });
  const [shop, setShop] = useState(null); // Current shop
  const [shopType, setShopType] = useState("");
  const [showQR, setShowQR] = useState(false); // Popup toggle
  const shopId = shop?.id || localStorage.getItem("shopkeeperID");

  // Guard against reaching this dashboard via browser back/forward after logout -
  // client-side routing re-renders this component on popstate without a full
  // reload, so without this check a cleared session would still show cached data.
  useEffect(() => {
    const isLoggedIn = () => {
      const role = (localStorage.getItem("role") || "").toUpperCase();
      return (
        !!localStorage.getItem("shopkeeperID") ||
        role === "SHOPKEEPER" ||
        role === "EMPLOYEE"
      );
    };

    if (!isLoggedIn()) {
      navigate("/MyAccountsSignIn", { replace: true });
      return;
    }

    // Re-check when a bfcache-restored page (e.g. after forward navigation) is shown.
    const handlePageShow = (event) => {
      if (event.persisted && !isLoggedIn()) {
        navigate("/MyAccountsSignIn", { replace: true });
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [navigate]);

  const [newProduct, setNewProduct] = useState({
    barcode: "",
    productName: "",
    group: "",
    subCategory: "",
    mrp: "",
    uom: "",
    hsnCode: "",
  });

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  //Handle the Profile AnchoreE1
  const handleProfileMenuOpen = (event) => {
    setProfileAnchorEl(event.currentTarget);
  };

  //wrap Invetory Table On Dashbaord
  const handleToggleInventory = () => {
    setShowInventoryTable((prev) => {
      const next = !prev;
      if (next && tableRef.current) {
        setTimeout(() => {
          tableRef.current.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
      return next;
    });
  };

  // Handle the Reports Anchore ok .
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (route) => {
    const shopkeeperID = localStorage.getItem("shopkeeperID");
    if (route === "/orderreports") {
      navigate(`/orderreports/${shopkeeperID}`);
    } else {
      navigate(route);
    }
    handleMenuClose();
  };

  const buttons = [
    { label: "My Orders", icon: <DashboardIcon />, path: "/customersorders" },
    // { label: "Inventory", icon: <InventoryIcon /> },
    // { label: "Cart", icon: <ShoppingCartIcon /> },

    // { label: "Settings", icon: <SettingsIcon /> }
  ];

  //  useEffect(() => {
  //   fetchProducts();
  // }, []);

  useEffect(() => {
    if (shopType) {
      fetchProducts(shopType);
    }
  }, [shopType]);

  // // 🔥 1. Put fetchProducts HERE (top section)
  // const fetchProducts = async () => {
  //   try {
  //     const response = await axios.get('https://sakhisshop.com/api/csv/getAllProduct');
  //     setProducts(response.data);
  //   } catch (error) {
  //     console.error('Error fetching products:', error);
  //   }
  // };
  const fetchProducts = async (shopType) => {
    try {
      const response = await axios.get(
        `https://sakhisshop.com/api/products/byShopType/${shopType}`,
      );
      setProducts(response.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // upladed excel button
  const fileInputRef = useRef(null);

  const handleExcelUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleExcelFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const shopkeeperID = localStorage.getItem("shopkeeperID");
    const shopType = shop?.shopType;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("shopkeeperId", shopkeeperID);
    // formData.append("shopType", shopType);

    try {
      const response = await axios.post(
        "https://sakhisshop.com/api/shops/upload-excel",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      alert("File Uploaded Successfully!");

      console.log("Uploaded Products:", response.data);

      // 👉 STEP A: append uploaded products to MasterInventory table
      if (response.data && Array.isArray(response.data)) {
        setProducts((prev) => [...prev, ...response.data]);
      }

      // 👉 STEP B: MyShopInventory ko update karne ke liye session
      sessionStorage.setItem("shopInventory", JSON.stringify(response.data));

      // 👉 STEP C: Fetch latest full products from DB
      //fetchProducts();
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Upload Failed!");
    }
  };

  // QR shop SHow For CUrrent shop
  useEffect(() => {
    const shopkeeperID = localStorage.getItem("shopkeeperID");
    console.log("Loaded shopkeeperID:", shopkeeperID);

    if (!shopkeeperID) {
      console.error("No shopkeeperID found in localStorage");
      return;
    }

    axios
      .get(`https://sakhisshop.com/api/shops/${shopkeeperID}`)
      .then((res) => {
        console.log("Shop API Response:", res.data);
        setShop(res.data);
        setShopName(res.data.shopName); // 👈 important

        setShopType(res.data.shopType);
        console.log("Shop Type:", res.data.shopType);
      })
      .catch((err) => console.error("Error fetching shop:", err));
  }, []);

  const downloadQR = async () => {
    const poster = document.getElementById("qrPoster");
    if (!poster) return;

    // Wait until all images load inside poster
    const images = poster.getElementsByTagName("img");
    await Promise.all(
      [...images].map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else img.onload = resolve;
          }),
      ),
    );

    toPng(poster, {
      cacheBust: true,
      imagePlaceholder: "",
      pixelRatio: 2,
    })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${shop?.shopName}-Poster.png`;
        link.click();
      })
      .catch((err) => console.error("Poster download failed:", err));
  };

  const printQR = async () => {
    const poster = document.getElementById("qrPoster");
    if (!poster) return;

    const images = poster.getElementsByTagName("img");
    await Promise.all(
      [...images].map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) resolve();
            else img.onload = resolve;
          }),
      ),
    );

    toPng(poster, { pixelRatio: 2 })
      .then((dataUrl) => {
        const w = window.open("");
        w.document.write(`<img src="${dataUrl}" style="width:100%;"/>`);
        w.document.close();
        w.focus();
        w.print();
        w.close();
      })
      .catch((err) => console.error("QR print failed:", err));
  };

  const handleProductSelection = (product) => {
    setSelectedProducts((prev) =>
      prev.some((item) => item.id === product.id)
        ? prev.filter((item) => item.id !== product.id)
        : [...prev, product],
    );
  };

  const handleCreateInventory = async () => {
    try {
      const rawShopkeeperId = localStorage.getItem("shopkeeperID");
      const shopkeeperId = parseInt(rawShopkeeperId);

      if (isNaN(shopkeeperId)) {
        alert("Something went wrong. Please log in again.");
        return;
      }

      // 🔍 1. Get existing inventory
      const inventoryResponse = await axios.get(
        `https://sakhisshop.com/api/shopkeeper/${shopkeeperId}/inventory`,
      );

      const existingInventory = inventoryResponse.data.inventory || [];

      const existingProductIds = existingInventory
        .filter((item) => item && item.productId) // ✅ use productId from DTO (not item.product.id)
        .map((item) => item.productId);

      // 🚫 2. Find duplicates
      const duplicateProducts = selectedProducts.filter((product) =>
        existingProductIds.includes(product.id),
      );

      if (duplicateProducts.length > 0) {
        alert(
          `Already in inventory:\n- ${duplicateProducts.map((p) => p.productName).join("\n")}`,
        );
        return;
      }

      // ✅ 3. Prepare payload
      const payload = {
        shopkeeperId,
        productIds: selectedProducts.map((p) => p.id),
      };

      await axios.post(
        "https://sakhisshop.com/api/shopkeeper/inventory",
        payload,
      );

      sessionStorage.setItem("shopInventory", JSON.stringify(selectedProducts));
      navigate("/myshop-inventory");
    } catch (error) {
      console.error("🚨 Error creating inventory:", error);
      alert("Failed to create inventory. Please try again.");
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // 1️⃣ Reusable button styles
  // const stylishButton = {
  //   borderRadius: "12px",
  //   fontWeight: 600,
  //   px: 6,
  //   py: 1.8,
  //   minWidth: { xs: 220, sm: 380 },
  //   fontSize: { xs: "1rem", sm: "1.25rem" },
  //   textTransform: "none",
  //   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  //   transition: "all 0.3s ease-in-out",
  //   "&:hover": {
  //     transform: "scale(1.05)",
  //     boxShadow: "0 6px 18px rgba(0,0,0,0.25)"
  //   },
  //   "& .MuiButton-startIcon": {
  //     transition: "transform 0.3s ease"
  //   },
  //   "&:hover .MuiButton-startIcon": {
  //     transform: "translateX(4px)"
  //   }
  // };

  const dashboardCard = {
    width: "100%",
    height: 170,
    borderRadius: "12px",
    p: 2,

    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",

    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
    },
  };
  const iconWrapper = (bg) => ({
    width: 52,
    height: 52,
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: bg,
  });

  // 2️⃣ Color variations
  // const greenButton = {
  //   ...stylishButton,
  //   background: "linear-gradient(135deg,#66bb6a,#43a047)",
  //   color: "#fff",
  //   "&:hover": {
  //     ...stylishButton["&:hover"],
  //     background: "linear-gradient(135deg,#43a047,#2e7d32)"
  //   }
  // };

  // const redButton = {
  //   ...stylishButton,
  //   background: "linear-gradient(135deg,#ef5350,#e53935)",
  //   color: "#fff",
  //   "&:hover": {
  //     ...stylishButton["&:hover"],
  //     background: "linear-gradient(135deg,#e53935,#c62828)"
  //   }
  // };

  // const blueButton = {
  //   ...stylishButton,
  //   background: "linear-gradient(135deg,#42a5f5,#478ed1)",
  //   color: "#fff",
  //   "&:hover": {
  //     ...stylishButton["&:hover"],
  //     background: "linear-gradient(135deg,#478ed1,#1e88e5)"
  //   }
  // };

  // const purpleButton = {
  //   ...stylishButton,
  //   background: "linear-gradient(135deg,#7e57c2,#5e35b1)",
  //   color: "#fff",
  //   "&:hover": {
  //     ...stylishButton["&:hover"],
  //     background: "linear-gradient(135deg,#5e35b1,#512da8)"
  //   }
  // };

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <Header2 />

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 1,
          pt: 7,
          px: 2, // left + right padding
        }}
      >
        {/* 1 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card
            sx={dashboardCard}
            onClick={() => setShowInventoryTable(!showInventoryTable)}
          >
            <Box sx={iconWrapper("#e8f5e9")}>
              <InventoryIcon sx={{ color: "#22c55e", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Master Inventory
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                Browse all products
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 2 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card
            sx={dashboardCard}
            onClick={() => navigate("/myshop-inventory")}
          >
            <Box sx={iconWrapper("#fff8e1")}>
              <StoreIcon sx={{ color: "#f59e0b", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Shop Inventory
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                Manage your items
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 3 */}
        {shop && (
          <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
            <Card sx={dashboardCard} onClick={() => setShowQR(true)}>
              <Box sx={iconWrapper("#f3e8ff")}>
                <QrCode2Icon sx={{ color: "#8b5cf6", fontSize: 26 }} />
              </Box>

              <Box>
                <Typography fontWeight={700} fontSize={16}>
                  My QR Code
                </Typography>

                <Typography fontSize={13} color="text.secondary">
                  View shop QR
                </Typography>
              </Box>
            </Card>
          </Box>
        )}

        <Dialog
          open={showQR}
          onClose={() => setShowQR(false)}
          fullScreen={isMobile}
          maxWidth="lg"
          PaperProps={{
            sx: {
              margin: 0,
              borderRadius: isMobile ? 0 : 3,
              overflow: "hidden",
            },
          }}
        >
          <DialogContent
            sx={{
              p: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: isMobile ? "flex-start" : "center", // 🔥 FIX
              bgcolor: "#e9efe9",
              overflowY: isMobile ? "auto" : "hidden", // 🔥 ALLOW SCROLL
            }}
          >
            <div
              id="qrPoster"
              style={{
                width: "100%",
                maxWidth: "960px",
                height: isMobile ? "auto" : "560px",
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                background: "#e6f3e6",
                fontFamily:
                  "'Poppins','Segoe UI','Noto Sans Devanagari',sans-serif",
              }}
            >
              {/* ================= LEFT POSTER ================= */}
              {/* <div
  style={{
    width: isMobile ? "100%" : "50%",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
   <img
  src="/images/poster-left-new.png"
      alt="Poster"
    style={{
      width: "100%",
      height: "auto",        // 🔥 MOST IMPORTANT
      maxHeight: isMobile ? "none" : "560px",
      objectFit: "contain",  // 🔥 NEVER CROP
      display: "block",
    }}
  /> 
</div> */}

              {/* ================= RIGHT SECTION ================= */}
              <div
                style={{
                  width: isMobile ? "100%" : "50%",
                  minHeight: isMobile ? "auto" : "100%",
                  display: "flex",
                  flexDirection: "column",
                  background: "#dff2df",
                }}
              >
                {/* ===== HEADER ===== */}
                <div
                  style={{
                    background: "#0b6623",
                    color: "#ffd700",
                    padding: "16px 12px",
                    textAlign: "center",
                  }}
                >
                  <h2
                    style={{
                      margin: 0,
                      fontWeight: 800,
                      letterSpacing: "0.8px",
                      color: "white",
                    }}
                  >
                    {shop?.shopName ||
                      shop?.shopname ||
                      localStorage.getItem("shopName") ||
                      "Shop Name"}
                  </h2>

                  <p
                    style={{
                      marginTop: 6,
                      fontSize: "13px",
                      color: "#ffffff",
                    }}
                  >
                    {shop?.address || "Shop Address"}
                  </p>
                </div>

                {/* ===== QR AREA ===== */}
                <div
                  style={{
                    flex: 1,
                    padding: "18px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: 800,
                      fontSize: "18px",
                      marginBottom: 14,
                    }}
                  >
                    QR कोड स्कॅन करा <br /> आणि कनेक्ट व्हा
                  </h3>

                  <div
                    style={{
                      background: "#ffffff",
                      padding: "14px",
                      borderRadius: 8,
                      border: "3px solid #0b6623",
                    }}
                  >
                    <QRCodeSVG
                      value={`https://sakhisshop.com/scan?sID=${shop?.sID}`}
                      size={isMobile ? 135 : 180}
                    />
                  </div>

                  <p
                    style={{
                      marginTop: 14,
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    वेळेवर आणि विश्वासार्ह ऑनलाइन खरेदी <br />
                    थेट तुमच्या मोबाईलवर!
                  </p>
                </div>

                {/* ===== FOOTER ===== */}
                <div
                  style={{
                    background: "#0b6623",
                    color: "#ffd700",
                    padding: "12px",
                    fontSize: "13px",
                    textAlign: "center",
                    fontWeight: 600,
                  }}
                >
                  📞 7066226680 &nbsp; | &nbsp; 🌐 www.sakhisshop.com &nbsp; |
                  &nbsp; ✉ support@sakhisshop.com
                </div>
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={downloadQR}>Download</Button>
            <Button onClick={() => setShowQR(false)} color="error">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* 4 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card sx={dashboardCard} onClick={() => navigate("/customersorders")}>
            <Box sx={iconWrapper("#e3f2fd")}>
              <ShoppingCartIcon sx={{ color: "#2196f3", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                My Orders
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                View orders
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 5 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card
            sx={dashboardCard}
            onClick={() => {
              const id = localStorage.getItem("shopkeeperID");
              navigate(`/orderreports/${id}`);
            }}
          >
            <Box sx={iconWrapper("#ede9fe")}>
              <ReceiptIcon sx={{ color: "#6366f1", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Order Reports
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                View reports
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 6 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card
            sx={dashboardCard}
            onClick={() => {
              const id = localStorage.getItem("shopkeeperID");
              navigate(`/salesReports/${id}`);
            }}
          >
            <Box sx={iconWrapper("#fce7f3")}>
              <DescriptionIcon sx={{ color: "#ec4899", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Sales Reports
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                View analytics
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 7 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card
            sx={dashboardCard}
            onClick={() => navigate("/pending-payments")}
          >
            <Box sx={iconWrapper("#fee2e2")}>
              <PaymentIcon sx={{ color: "#ef4444", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Receivable
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                Pending payments
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 8 */}
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleExcelFileChange}
        />

        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card sx={dashboardCard} onClick={handleExcelUploadClick}>
            <Box sx={iconWrapper("#e0e7ff")}>
              <UploadFileIcon sx={{ color: "#4f46e5", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Upload Excel
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                Import products
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 9 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card sx={dashboardCard} onClick={() => navigate("/label-studio")}>
            <Box sx={iconWrapper("#e0e7ff")}>
              <DescriptionIcon sx={{ color: "#4f46e5", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Label Studio
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                Design &amp; print product labels
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* 10 */}
        <Box sx={{ width: "calc(50% - 8px)", display: "flex" }}>
          <Card
            sx={dashboardCard}
            onClick={() => navigate("/MyAccountSetting")}
          >
            <Box sx={iconWrapper("#ecfeff")}>
              <SettingsIcon sx={{ color: "#0891b2", fontSize: 26 }} />
            </Box>

            <Box>
              <Typography fontWeight={700} fontSize={16}>
                Account Settings
              </Typography>

              <Typography fontSize={13} color="text.secondary">
                Open profile and delete account
              </Typography>
            </Box>
          </Card>
        </Box>

        {/* Inventory Table */}
        {showInventoryTable && (
          <TableContainer
            component={Paper}
            sx={{
              mt: 2,
              borderRadius: 3,
              boxShadow: "0px 5px 20px rgba(0,0,0,0.1)",
              overflowX: "auto",
            }}
          >
            <Box display="flex" justifyContent="flex-end" mb={1} py={1}>
              <TextField
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <VisibilityIcon />
                    </InputAdornment>
                  ),
                  style: { backgroundColor: "white" },
                }}
                sx={{ width: 350, ml: 2 }}
              />
            </Box>

            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    background: "linear-gradient(45deg,rgb(37, 117, 126))",
                  }}
                >
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Select
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    ID
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Barcode
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Product Name
                  </TableCell>

                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Group
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    Sub Category
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    UOM
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    MRP
                  </TableCell>
                  {/* <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>HSN Code</TableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {(Array.isArray(products) ? products : [])
                  .filter((product) =>
                    product.productName
                      ?.toLowerCase()
                      .includes((searchQuery || "").toLowerCase()),
                  )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((product) => (
                    <TableRow key={product.id} hover>
                      <TableCell>
                        <Checkbox
                          checked={selectedProducts.some(
                            (item) => item.id === product.id,
                          )}
                          onChange={() => handleProductSelection(product)}
                        />
                      </TableCell>

                      <TableCell>{product.id}</TableCell>
                      <TableCell>{product.barcode}</TableCell>
                      <TableCell>{product.productName}</TableCell>
                      <TableCell>{product.group}</TableCell>
                      <TableCell>{product.subCategory}</TableCell>
                      <TableCell>{product.uom}</TableCell>
                      <TableCell>₹{product.mrp}</TableCell>
                      <TableCell>{product.hsnCode}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={
                (Array.isArray(products) ? products : []).filter((product) =>
                  product.productName
                    ?.toLowerCase()
                    .includes((searchQuery || "").toLowerCase()),
                ).length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}

        {/* Action Button */}
        {showInventoryTable && (
          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="body1" sx={{ mb: 2, fontWeight: "bold" }}>
              Selected Products: {selectedProducts.length}
            </Typography>
            <Button
              variant="contained"
              onClick={handleCreateInventory}
              disabled={selectedProducts.length === 0}
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                padding: "12px 28px",
                borderRadius: "10px",
                background: "linear-gradient(45deg, #512DA8, #673AB7)",
                color: "#fff",
                "&:hover": {
                  background: "linear-gradient(45deg, #ff4757, #ff6348)",
                },
                "&:disabled": {
                  background: "#e0e0e0",
                  color: "#888",
                },
              }}
            >
              Create My Shop Inventory
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
}

export default CreateShopKeeperInv;
